/* eslint "jsx-a11y/no-static-element-interactions": "off" */
import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { isMobile } from 'utils/helpers';

const propTypes = {
  children: PropTypes.any,
  nodeRef: PropTypes.any,
  isOpen: PropTypes.bool,
  onBackdropClick: PropTypes.func,
  onEscapeKeyUp: PropTypes.func,
  isConfirmationView: PropTypes.bool,
};

const defaultProps = {
  onBackdropClick: () => { },
};

class PositionedOverlay extends Component {
  constructor() {
    super();
    this.state = {
      overlayRef: null,
      contentRef: null,
    };
    this.setOverlayRef = this.setOverlayRef.bind(this);
    this.setContentRef = this.setContentRef.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onBackdropClick = this.onBackdropClick.bind(this);
    this.makeContentRefVisibleIfNeeded = this.makeContentRefVisibleIfNeeded.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keyup', this.onKeyUp);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.isOpen && nextProps.isOpen) {
      const classes = document.body.className;
      document.body.className = `${classes} overlay-open`;
    } else if (this.props.isOpen && !nextProps.isOpen) {
      document.body.className = document.body.className.replace('overlay-open', '');
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onKeyUp);
    document.body.className = document.body.className.replace('overlay-open', '');
  }

  onKeyUp(e) {
    const { onEscapeKeyUp } = this.props;
    if (onEscapeKeyUp && (e.key === 'Escape' || e.keyCode === 27)) {
      onEscapeKeyUp();
    }
  }

  onBackdropClick(e) {
    if (e.target === this.state.overlayRef) {
      this.props.onBackdropClick();
    }
  }

  setOverlayRef(node) {
    this.setState({
      overlayRef: node,
    });
  }

  setContentRef(node) {
    this.makeContentRefVisibleIfNeeded(node);
    this.setState({
      contentRef: node,
    });
  }

  makeContentRefVisibleIfNeeded(contentRef) {
    if (!MOBILE_WALLET && this.props.isConfirmationView && contentRef) {
      const viewportOffset = contentRef.getBoundingClientRect();
      if (viewportOffset.top < 0) {
        window.scrollTo(0, (viewportOffset.top - 8) + window.scrollY);
      } else if (viewportOffset.bottom > window.innerHeight) {
        window.scrollTo(0, window.scrollY + (viewportOffset.bottom - window.innerHeight + 8));
      }
    }
  }

  render() {
    const { nodeRef, isOpen } = this.props;
    const { contentRef } = this.state;

    if (!isOpen || (!nodeRef && !MOBILE_WALLET)) {
      return null;
    }

    let overlayStyles = {};
    let contentStyles = {};

    if (!MOBILE_WALLET) {
      const { top, left, width } = nodeRef.getBoundingClientRect();
      const { paddingTop, paddingBottom } = getComputedStyle(nodeRef);
      let height = nodeRef.getBoundingClientRect().height;

      if (contentRef && contentRef.scrollHeight > height) {
        height = contentRef.scrollHeight;
      }

      overlayStyles = {
        position: 'absolute', top, left, width,
      };
      contentStyles = {
        minHeight: height - parseInt(paddingTop, 10) - parseInt(paddingBottom, 10),
      };
      if (isMobile && height > window.innerHeight) {
        overlayStyles.overflowY = 'scroll';
        overlayStyles.minWidth = '100vw';
        contentStyles.minHeight = '100vh';
      } else {
        overlayStyles.minHeight = height;
      }
    }

    return createPortal(
      <div
        className="overlay"
        onClick={this.onBackdropClick}
        onKeyUp={this.onKeyUp}
        ref={this.setOverlayRef}
      >
        <div
          className="content-block content-block--type-overlay"
          style={overlayStyles}
          ref={this.setContentRef}
        >
          <div
            className="content-block__overlay-content"
            style={contentStyles}
          >
            {this.props.children}
          </div>
        </div>
      </div>,
      document.querySelector('#app-overlays')
    );
  }
}

PositionedOverlay.propTypes = propTypes;
PositionedOverlay.defaultProps = defaultProps;

export default PositionedOverlay;
